module.exports = __webpack_public_path__ + "static/media/anatomia.b7d8a62d.png";